import React, { useEffect, useState } from "react";
import {
    makeStyles,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Divider,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import apiConfigs from "../../config/config";
import { updateRoles } from "../../store/action";
import Notification from "../../components/Notification/Notification";

const useStyle = makeStyles((theme) => ({
    dialogWidth: { width: "100%" },
    radioGroup: {
        flexDirection: "row",
    },
}));

function UpdateRoles({ open, handleClose, id }) {
    const classes = useStyle();
    const dispatch = useDispatch();
    const [rolesNotify, setRolesNotify] = useState(false);
    const { getRolesItem, getRolesError } = useSelector(
        (state) => state.roles
    );
    const [data, setData] = useState({
        name: ''
    });

    const handleChange = (event) => {
        setData({ ...data, [event.target.name]: event.target.value });
    };

    const rolesSubmit = (event) => {
        event.preventDefault();
        dispatch(updateRoles(data));
        setRolesNotify(true);
    };

    useEffect(() => {
        if (getRolesItem?.id) {
            handleClose();
        }
    }, [getRolesItem]);

    const getData = async (id) => {
        if (id > 0) {
            const loggedInUser = localStorage.getItem("token").replace(/['"]+/g, "");
            axios
                .get(`${apiConfigs.API_URL}api/organization/get-role/${id}`, {
                    headers: {
                        "content-type": "application/json",
                        Authorization: `Bearer ${loggedInUser}`,
                    },
                })
                .then((response) => {
                    setData(response.data.data);
                })
                .catch((error) => {
                    console.error("error.message", error.message);
                });
        }
    };
    useEffect(() => {
        setData("");
        getData(id);
    }, [id]);

    const handleClose1 = () => {
        handleClose();
        // reset();
    };

    return (
        <>
            {rolesNotify && getRolesItem?.message && (
                <Notification data={getRolesItem?.message} status="success" />
            )}

            {/* {specilaityNotify && speUpdateErrors?.message &&
                <Notification
                    data={speUpdateErrors?.message}
                    status="error"
                />
            } */}
            <Dialog
                open={open}
                onClose={handleClose1}
                classes={{ paper: classes.dialogWidth }}
            >
                <form>
                    <DialogTitle id="form-dialog-title">
                        <div>Update Roles</div>
                    </DialogTitle>
                    <Divider />
                    <DialogContent>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="role_name"
                            label="Roles"
                            variant="outlined"
                            name="name"
                            value={data?.name ? data?.name : ""}
                            fullWidth
                            error={getRolesError?.message ? true : false}
                            helperText={
                                getRolesError?.message ? getRolesError?.message : ""
                            }
                            onChange={handleChange}
                            required
                        />
                    </DialogContent>
                    <DialogActions className="pr-4 pb-2">
                        <Button onClick={handleClose1} color="primary">
                            Cancel
                        </Button>
                        <Button
                            color="secondary"
                            type="submit"
                            variant="contained"
                            onClick={(event) => rolesSubmit(event)}
                            formNoValidate
                        >
                            Update
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </>
    );
}

export default UpdateRoles;
